export default __webpack_public_path__ + "static/media/expl-nn_03_EN.1ce96100.png";